// import React, { useState, useEffect } from "react";
// import { createPortal } from "react-dom";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import {
//   RiArrowLeftLine,
//   RiAddLine,
//   RiDeleteBinLine,
//   RiCheckLine,
//   RiCloseLine,
//   RiErrorWarningLine,
//   RiSplitCellsHorizontal,
//   RiBuilding2Line,
//   RiBankLine,
//   RiFileTextLine,
//   RiSaveLine,
//   RiInboxLine,
//   RiUserAddLine,
//   RiUserLine,
//   RiPhoneLine,
//   RiMapPinLine,
//   RiMailLine,
//   RiHashtag,
//   RiPrinterLine,
//   RiDownloadLine,
//   RiEyeLine,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import { LiaRupeeSignSolid } from "react-icons/lia";
// import { FaCodeBranch } from "react-icons/fa";

// const BASE_URL = process.env.REACT_APP_API_URL;

// const Spinner = ({ className = "w-4 h-4" }) => (
//   <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
// );

// const fmt = (n) =>
//   Number(n || 0).toLocaleString("en-IN", {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });

// const calcGST = (subTotal, cgstRate = 2.5, sgstRate = 2.5) => {
//   const s = Number(subTotal) || 0;
//   const cgst = parseFloat(((s * cgstRate) / 100).toFixed(2));
//   const sgst = parseFloat(((s * sgstRate) / 100).toFixed(2));
//   const total = parseFloat((s + cgst + sgst).toFixed(2));
//   return { cgst, sgst, total };
// };

// const getBorrowerSubTotal = (b) =>
//   parseFloat(((Number(b.perAcc) || 0) * (Number(b.acc) || 0)).toFixed(2));

// const newBorrower = () => ({
//   id: crypto.randomUUID(),
//   borrowersName: "",
//   perAcc: "",
//   acc: 1,
// });

// const newBranchGroup = () => ({
//   id: crypto.randomUUID(),
//   branchId: "",
//   branchName: "",
//   borrowers: [newBorrower()],
// });

// const inputCls =
//   "w-full bg-blue-50/60 border border-blue-200 rounded-xl px-3 py-2 text-xs text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition";

// /* ─── Toast ─── */
// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 3500);
//     return () => clearTimeout(t);
//   }, [onClose]);
//   return (
//     <div
//       className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button onClick={onClose} className="ml-2 opacity-50 hover:opacity-100">
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// /* ─── Split Bill Summary Modal ─── */
// const SplitBillSummaryModal = ({
//   invoice,
//   splitBills,
//   splitBillType,
//   onClose,
// }) => {
//   return createPortal(
//     <div className="fixed inset-0 z-50 flex items-center justify-center">
//       <div
//         className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
//         onClick={onClose}
//       />
//       <div className="relative z-10 w-full max-w-4xl mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
//         {/* Modal Header */}
//         <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-gradient-to-r from-blue-50 to-violet-50 flex-shrink-0">
//           <div className="flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-md shadow-violet-200">
//               <RiFileTextLine className="w-4 h-4" />
//             </div>
//             <div>
//               <h2 className="text-sm font-bold text-blue-900">
//                 Split Bill Summary
//               </h2>
//               <p className="text-[11px] text-blue-400 font-medium">
//                 Invoice: {invoice?.invoiceNumber}
//               </p>
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
//           >
//             <RiCloseLine className="w-5 h-5" />
//           </button>
//         </div>

//         {/* Modal Body */}
//         <div className="p-6 overflow-y-auto flex-1">
//           {/* Summary Cards */}
//           <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
//             <div className="bg-blue-50 rounded-xl p-3 text-center">
//               <div className="text-[10px] text-blue-600 uppercase font-bold">
//                 Total Split Bills
//               </div>
//               <div className="text-2xl font-bold text-blue-800">
//                 {splitBills?.length || 0}
//               </div>
//             </div>
//             <div className="bg-indigo-50 rounded-xl p-3 text-center">
//               <div className="text-[10px] text-indigo-600 uppercase font-bold">
//                 Total Sub Total
//               </div>
//               <div className="text-2xl font-bold text-indigo-800">
//                 ₹{fmt(splitBills?.reduce((s, b) => s + b.subTotal, 0) || 0)}
//               </div>
//             </div>
//             <div className="bg-violet-50 rounded-xl p-3 text-center">
//               <div className="text-[10px] text-violet-600 uppercase font-bold">
//                 Total GST
//               </div>
//               <div className="text-2xl font-bold text-violet-800">
//                 ₹
//                 {fmt(
//                   splitBills?.reduce(
//                     (s, b) => s + (b.cgst || 0) + (b.sgst || 0),
//                     0,
//                   ) || 0,
//                 )}
//               </div>
//             </div>
//             <div className="bg-emerald-50 rounded-xl p-3 text-center">
//               <div className="text-[10px] text-emerald-600 uppercase font-bold">
//                 Total Amount
//               </div>
//               <div className="text-2xl font-bold text-emerald-800">
//                 ₹{fmt(splitBills?.reduce((s, b) => s + b.total, 0) || 0)}
//               </div>
//             </div>
//           </div>

//           {/* Split Bills Table */}
//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="border-b border-blue-100 bg-slate-50">
//                   <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-400 uppercase">
//                     #
//                   </th>
//                   <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-400 uppercase">
//                     Sub-client
//                   </th>
//                   <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-400 uppercase">
//                     Borrower
//                   </th>
//                   <th className="px-4 py-2 text-right text-[10px] font-semibold text-slate-400 uppercase">
//                     Sub Total
//                   </th>
//                   <th className="px-4 py-2 text-right text-[10px] font-semibold text-slate-400 uppercase">
//                     CGST
//                   </th>
//                   <th className="px-4 py-2 text-right text-[10px] font-semibold text-slate-400 uppercase">
//                     SGST
//                   </th>
//                   <th className="px-4 py-2 text-right text-[10px] font-semibold text-slate-400 uppercase">
//                     Total
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {splitBills?.map((bill, idx) => (
//                   <tr
//                     key={idx}
//                     className="border-b border-slate-50 hover:bg-blue-50/20"
//                   >
//                     <td className="px-4 py-3 text-xs text-slate-500 font-mono">
//                       {idx + 1}
//                     </td>
//                     <td className="px-4 py-3 text-xs font-semibold text-slate-700">
//                       {bill.branchName}
//                     </td>
//                     <td className="px-4 py-3 text-xs text-slate-600">
//                       {bill.borrowersName}
//                     </td>
//                     <td className="px-4 py-3 text-right text-xs font-mono text-slate-700">
//                       ₹{fmt(bill.subTotal)}
//                     </td>
//                     <td className="px-4 py-3 text-right text-xs font-mono text-slate-600">
//                       ₹{fmt(bill.cgst)}
//                     </td>
//                     <td className="px-4 py-3 text-right text-xs font-mono text-slate-600">
//                       ₹{fmt(bill.sgst)}
//                     </td>
//                     <td className="px-4 py-3 text-right text-xs font-mono font-bold text-indigo-700">
//                       ₹{fmt(bill.total)}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//               <tfoot className="bg-slate-50 border-t border-blue-100">
//                 <tr>
//                   <td
//                     colSpan={3}
//                     className="px-4 py-3 text-xs font-bold text-slate-600"
//                   >
//                     Total
//                   </td>
//                   <td className="px-4 py-3 text-right text-xs font-bold font-mono text-slate-800">
//                     ₹{fmt(splitBills?.reduce((s, b) => s + b.subTotal, 0))}
//                   </td>
//                   <td className="px-4 py-3 text-right text-xs font-bold font-mono text-slate-800">
//                     ₹{fmt(splitBills?.reduce((s, b) => s + (b.cgst || 0), 0))}
//                   </td>
//                   <td className="px-4 py-3 text-right text-xs font-bold font-mono text-slate-800">
//                     ₹{fmt(splitBills?.reduce((s, b) => s + (b.sgst || 0), 0))}
//                   </td>
//                   <td className="px-4 py-3 text-right text-xs font-bold font-mono text-indigo-800">
//                     ₹{fmt(splitBills?.reduce((s, b) => s + b.total, 0))}
//                   </td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//         </div>

//         {/* Modal Footer */}
//         <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-blue-50 bg-slate-50/50 flex-shrink-0">
//           <button
//             onClick={onClose}
//             className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
//           >
//             <RiCloseLine className="w-4 h-4" /> Close
//           </button>
//         </div>
//       </div>
//     </div>,
//     document.body,
//   );
// };

// /* ─── Add Sub-client Modal ─── */
// const defaultSubClientForm = {
//   branchName: "",
//   contactPerson: "",
//   phone: "",
//   email: "",
//   address: "",
//   pin: "",
// };

// const subClientFields = [
//   {
//     label: "Sub-client Name",
//     name: "branchName",
//     icon: FaCodeBranch,
//     required: true,
//   },
//   { label: "Contact Person", name: "contactPerson", icon: RiUserLine },
//   { label: "Phone", name: "phone", icon: RiPhoneLine, type: "tel" },
//   { label: "Email", name: "email", icon: RiMailLine, type: "email" },
//   { label: "Address", name: "address", icon: RiMapPinLine },
//   { label: "PIN", name: "pin", icon: RiHashtag },
// ];

// const SubClientModal = ({ bankId, clientName, onClose, onCreated, notify }) => {
//   const [form, setForm] = useState(defaultSubClientForm);
//   const [saving, setSaving] = useState(false);

//   const handleChange = (e) =>
//     setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

//   const handleCreate = async () => {
//     if (!form.branchName.trim()) {
//       notify("Sub-client name is required", "error");
//       return;
//     }
//     if (!bankId) {
//       notify("No client ID found for this invoice", "error");
//       return;
//     }
//     setSaving(true);
//     try {
//       const res = await axios.post(`${BASE_URL}/branch/create-branch`, {
//         ...form,
//         bankId,
//       });
//       const created = res.data?.data || res.data;
//       notify("Sub-client created successfully");
//       onCreated(created);
//     } catch (err) {
//       notify(
//         err?.response?.data?.message || "Failed to create sub-client",
//         "error",
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   return createPortal(
//     <div className="fixed inset-0 z-50 flex items-center justify-center">
//       <div
//         className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
//         onClick={onClose}
//       />
//       <div className="relative z-10 w-full max-w-lg mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden">
//         {/* Modal Header */}
//         <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-gradient-to-r from-blue-50 to-violet-50">
//           <div className="flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-md shadow-violet-200">
//               <FaCodeBranch className="w-4 h-4" />
//             </div>
//             <div>
//               <h2 className="text-sm font-bold text-blue-900">
//                 Add Sub-client
//               </h2>
//               {clientName && (
//                 <p className="text-[11px] text-blue-400 font-medium">
//                   Under:{" "}
//                   <span className="text-violet-600 font-bold">
//                     {clientName}
//                   </span>
//                 </p>
//               )}
//             </div>
//           </div>
//           <button
//             onClick={onClose}
//             className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
//           >
//             <RiCloseLine className="w-5 h-5" />
//           </button>
//         </div>

//         <div className="p-6 space-y-4">
//           <div className="grid grid-cols-2 gap-3">
//             {subClientFields.map(
//               ({ label, name, icon: Icon, type = "text", required }) => (
//                 <div
//                   key={name}
//                   className={name === "address" ? "col-span-2" : "col-span-1"}
//                 >
//                   <label className="text-[10px] font-bold text-blue-600 uppercase tracking-widest mb-1.5 block">
//                     {label}
//                     {required && <span className="text-red-400 ml-0.5">*</span>}
//                   </label>
//                   <div className="relative">
//                     <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-blue-300 pointer-events-none" />
//                     <input
//                       type={type}
//                       name={name}
//                       value={form[name]}
//                       onChange={handleChange}
//                       placeholder={label}
//                       className="w-full bg-blue-50/60 border border-blue-200 rounded-xl pl-8 pr-3 py-2 text-xs text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//                     />
//                   </div>
//                 </div>
//               ),
//             )}
//           </div>
//         </div>

//         {/* Modal Footer */}
//         <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-blue-50 bg-slate-50/50">
//           <button
//             onClick={onClose}
//             className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
//           >
//             <RiCloseLine className="w-4 h-4" /> Cancel
//           </button>
//           <button
//             onClick={handleCreate}
//             disabled={saving}
//             className="flex items-center gap-2 px-5 py-2 rounded-xl text-sm font-bold bg-violet-600 hover:bg-violet-700 text-white transition shadow-md shadow-violet-200 disabled:opacity-60"
//           >
//             {saving ? <Spinner /> : <RiCheckLine className="w-4 h-4" />}
//             {saving ? "Creating…" : "Create Sub-client"}
//           </button>
//         </div>
//       </div>
//     </div>,
//     document.body,
//   );
// };

// /* ─── Summary Bar ─── */
// const SummaryBar = ({
//   invoiceSubTotal,
//   allocatedSubTotal,
//   allocatedTotal,
//   branchCount,
//   borrowerCount,
// }) => {
//   const remaining = invoiceSubTotal - allocatedSubTotal;
//   const isOver = remaining < -0.005;
//   const isBalanced = Math.abs(remaining) < 0.005;

//   return (
//     <div className="bg-white border border-blue-100 rounded-2xl shadow-sm px-6 py-4 flex flex-wrap items-center gap-6">
//       <div className="flex flex-col">
//         <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
//           Invoice Sub Total
//         </span>
//         <span className="text-lg font-extrabold text-slate-800 font-mono">
//           ₹{fmt(invoiceSubTotal)}
//         </span>
//       </div>
//       <div className="h-8 w-px bg-slate-100" />
//       <div className="flex flex-col">
//         <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
//           Allocated Sub Total ({branchCount} sub-client
//           {branchCount !== 1 ? "s" : ""}, {borrowerCount} borrower
//           {borrowerCount !== 1 ? "s" : ""})
//         </span>
//         <span className="text-lg font-extrabold text-indigo-700 font-mono">
//           ₹{fmt(allocatedSubTotal)}
//         </span>
//       </div>
//       <div className="h-8 w-px bg-slate-100" />
//       <div className="flex flex-col">
//         <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
//           Allocated Grand Total (with GST)
//         </span>
//         <span className="text-lg font-extrabold text-violet-700 font-mono">
//           ₹{fmt(allocatedTotal)}
//         </span>
//       </div>
//       <div className="h-8 w-px bg-slate-100" />
//       <div className="flex flex-col">
//         <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
//           Remaining (Sub Total)
//         </span>
//         <span
//           className={`text-lg font-extrabold font-mono ${
//             isBalanced
//               ? "text-emerald-600"
//               : isOver
//                 ? "text-red-600"
//                 : "text-amber-600"
//           }`}
//         >
//           ₹{fmt(Math.abs(remaining))}
//           {isOver ? " (over)" : isBalanced ? " ✓" : ""}
//         </span>
//       </div>
//       <div className="ml-auto">
//         {isBalanced ? (
//           <span className="flex items-center gap-1.5 text-xs font-bold text-emerald-600 bg-emerald-50 border border-emerald-200 px-3 py-1.5 rounded-lg">
//             <RiCheckLine className="w-3.5 h-3.5" />
//             Balanced
//           </span>
//         ) : isOver ? (
//           <span className="flex items-center gap-1.5 text-xs font-bold text-red-600 bg-red-50 border border-red-200 px-3 py-1.5 rounded-lg">
//             <RiErrorWarningLine className="w-3.5 h-3.5" />
//             Over-allocated
//           </span>
//         ) : (
//           <span className="flex items-center gap-1.5 text-xs font-bold text-amber-600 bg-amber-50 border border-amber-200 px-3 py-1.5 rounded-lg">
//             <RiErrorWarningLine className="w-3.5 h-3.5" />
//             Not balanced
//           </span>
//         )}
//       </div>
//     </div>
//   );
// };

// /* ─── Branch Group ─── */
// const BranchGroup = ({
//   group,
//   groupIdx,
//   branches,
//   bankId,
//   clientName,
//   onUpdateGroup,
//   onRemoveGroup,
//   onAddBorrower,
//   onUpdateBorrower,
//   onRemoveBorrower,
//   onBranchCreated,
//   notify,
// }) => {
//   const [showSubClientModal, setShowSubClientModal] = useState(false);

//   const groupSubTotal = group.borrowers.reduce(
//     (s, b) => s + getBorrowerSubTotal(b),
//     0,
//   );
//   const {
//     cgst: groupCgst,
//     sgst: groupSgst,
//     total: groupTotal,
//   } = calcGST(groupSubTotal);

//   /* After a new sub-client is created, refresh branches + auto-select it */
//   const handleSubClientCreated = (newBranch) => {
//     onBranchCreated(newBranch, groupIdx);
//     setShowSubClientModal(false);
//   };

//   return (
//     <>
//       <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
//         {/* Group Header */}
//         <div className="flex items-center gap-3 px-5 py-3.5 bg-blue-50/40 border-b border-blue-100 flex-wrap">
//           <div className="w-7 h-7 rounded-lg bg-indigo-100 flex items-center justify-center flex-shrink-0">
//             <FaCodeBranch className="w-3.5 h-3.5 text-indigo-600" />
//           </div>

//           {/* Sub-client select dropdown */}
//           <select
//             value={group.branchId}
//             onChange={(e) => {
//               const selected = branches.find((b) => b._id === e.target.value);
//               onUpdateGroup(groupIdx, {
//                 branchId: e.target.value,
//                 branchName: selected?.branchName || "",
//               });
//             }}
//             className="flex-1 min-w-[180px] px-3 py-1.5 bg-white border border-blue-200 rounded-xl text-sm font-semibold text-slate-700 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//           >
//             <option value="">— Select Sub-client —</option>
//             {branches.map((b) => (
//               <option key={b._id} value={b._id}>
//                 {b.branchName}
//               </option>
//             ))}
//           </select>

//           {/* ── Add Sub-client button ── */}
//           <button
//             onClick={() => setShowSubClientModal(true)}
//             className="flex items-center gap-1.5 px-3 py-1.5 bg-violet-50 border border-violet-200 text-violet-700 rounded-xl text-xs font-bold hover:bg-violet-100 transition flex-shrink-0"
//             title="Create a new sub-client"
//           >
//             <FaCodeBranch className="w-3.5 h-3.5" />
//             <span className="hidden sm:inline">Add Sub-client</span>
//           </button>

//           {/* Totals pill */}
//           <div className="hidden sm:flex items-center gap-3 bg-white border border-indigo-100 rounded-xl px-4 py-1.5 text-xs font-mono flex-shrink-0">
//             <span className="text-slate-400">Sub</span>
//             <span className="font-bold text-indigo-700">
//               ₹{fmt(groupSubTotal)}
//             </span>
//             <span className="text-slate-300">|</span>
//             <span className="text-slate-400">Total</span>
//             <span className="font-bold text-indigo-800">
//               ₹{fmt(groupTotal)}
//             </span>
//           </div>

//           {/* Add Borrower */}
//           <button
//             onClick={() => onAddBorrower(groupIdx)}
//             className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 border border-blue-200 text-blue-700 rounded-xl text-xs font-bold hover:bg-blue-100 transition flex-shrink-0"
//           >
//             <RiUserAddLine className="w-3.5 h-3.5" />
//             <span className="hidden sm:inline">Add Borrower</span>
//           </button>

//           {/* Remove group */}
//           <button
//             onClick={() => onRemoveGroup(groupIdx)}
//             className="w-8 h-8 flex items-center justify-center rounded-lg border border-red-100 text-red-300 hover:text-red-600 hover:bg-red-50 hover:border-red-200 transition flex-shrink-0"
//             title="Remove sub-client"
//           >
//             <RiDeleteBinLine className="w-4 h-4" />
//           </button>
//         </div>

//         {/* Borrowers Table */}
//         <div className="overflow-x-auto">
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="border-b border-blue-50 bg-slate-50/60">
//                 {[
//                   "#",
//                   "Borrower's Name",
//                   "Per A/C (₹)",
//                   "A/C No.",
//                   "Sub Total (₹)",
//                   "CGST (2.5%)",
//                   "SGST (2.5%)",
//                   "Total (₹)",
//                   "",
//                 ].map((h) => (
//                   <th
//                     key={h}
//                     className="px-4 py-2.5 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-widest whitespace-nowrap"
//                   >
//                     {h}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {group.borrowers.map((b, bIdx) => {
//                 const subTotal = getBorrowerSubTotal(b);
//                 const { cgst, sgst, total } = calcGST(subTotal);
//                 return (
//                   <tr
//                     key={b.id}
//                     className="border-b border-slate-50 hover:bg-blue-50/10 transition"
//                   >
//                     <td className="px-4 py-2.5 text-xs text-slate-400 font-mono">
//                       {bIdx + 1}
//                     </td>
//                     <td className="px-3 py-2">
//                       <div className="relative">
//                         <RiUserLine className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-blue-300 pointer-events-none" />
//                         <input
//                           type="text"
//                           value={b.borrowersName}
//                           onChange={(e) =>
//                             onUpdateBorrower(groupIdx, bIdx, {
//                               borrowersName: e.target.value,
//                             })
//                           }
//                           placeholder="Borrower's name"
//                           className="w-full min-w-[160px] pl-8 pr-3 py-2 bg-blue-50/60 border border-blue-200 rounded-xl text-xs text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//                         />
//                       </div>
//                     </td>
//                     <td className="px-3 py-2">
//                       <input
//                         type="number"
//                         value={b.perAcc}
//                         onChange={(e) =>
//                           onUpdateBorrower(groupIdx, bIdx, {
//                             perAcc: e.target.value,
//                           })
//                         }
//                         placeholder="0"
//                         min={0}
//                         className="w-24 px-3 py-2 bg-blue-50/60 border border-blue-200 rounded-xl text-xs text-slate-700 font-mono placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//                       />
//                     </td>
//                     <td className="px-3 py-2">
//                       <input
//                         type="number"
//                         value={b.acc}
//                         min={1}
//                         onChange={(e) =>
//                           onUpdateBorrower(groupIdx, bIdx, {
//                             acc: e.target.value,
//                           })
//                         }
//                         placeholder="1"
//                         className="w-20 px-3 py-2 bg-blue-50/60 border border-blue-200 rounded-xl text-xs text-slate-700 font-mono placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
//                       />
//                     </td>
//                     <td className="px-4 py-2.5 text-xs font-mono text-slate-700 whitespace-nowrap">
//                       <span className="inline-flex items-center gap-1 bg-slate-50 border border-slate-200 rounded-lg px-3 py-1.5 font-bold text-slate-700">
//                         ₹{fmt(subTotal)}
//                       </span>
//                     </td>
//                     <td className="px-4 py-2.5 text-xs font-mono text-slate-500 whitespace-nowrap">
//                       ₹{fmt(cgst)}
//                     </td>
//                     <td className="px-4 py-2.5 text-xs font-mono text-slate-500 whitespace-nowrap">
//                       ₹{fmt(sgst)}
//                     </td>
//                     <td className="px-4 py-2.5 whitespace-nowrap">
//                       <span className="font-extrabold text-indigo-700 font-mono text-sm">
//                         ₹{fmt(total)}
//                       </span>
//                     </td>
//                     <td className="px-4 py-2.5">
//                       <button
//                         onClick={() => onRemoveBorrower(groupIdx, bIdx)}
//                         disabled={group.borrowers.length === 1}
//                         className="w-7 h-7 flex items-center justify-center rounded-lg border border-red-100 text-red-300 hover:text-red-600 hover:bg-red-50 hover:border-red-200 transition disabled:opacity-30 disabled:cursor-not-allowed"
//                         title="Remove borrower"
//                       >
//                         <RiCloseLine className="w-3.5 h-3.5" />
//                       </button>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>

//             {group.borrowers.length > 1 && (
//               <tfoot>
//                 <tr className="bg-indigo-50/50 border-t border-indigo-100">
//                   <td
//                     colSpan={4}
//                     className="px-4 py-2.5 text-[10px] font-bold text-indigo-600 uppercase tracking-widest"
//                   >
//                     Sub-client Total ({group.borrowers.length} borrowers)
//                   </td>
//                   <td className="px-4 py-2.5 text-xs font-bold font-mono text-slate-700">
//                     ₹{fmt(groupSubTotal)}
//                   </td>
//                   <td className="px-4 py-2.5 text-xs font-bold font-mono text-slate-700">
//                     ₹{fmt(groupCgst)}
//                   </td>
//                   <td className="px-4 py-2.5 text-xs font-bold font-mono text-slate-700">
//                     ₹{fmt(groupSgst)}
//                   </td>
//                   <td className="px-4 py-2.5">
//                     <span className="font-extrabold text-indigo-800 font-mono text-sm">
//                       ₹{fmt(groupTotal)}
//                     </span>
//                   </td>
//                   <td />
//                 </tr>
//               </tfoot>
//             )}
//           </table>
//         </div>
//       </div>

//       {/* ── Sub-client creation modal ── */}
//       {showSubClientModal && (
//         <SubClientModal
//           bankId={bankId}
//           clientName={clientName}
//           onClose={() => setShowSubClientModal(false)}
//           onCreated={handleSubClientCreated}
//           notify={notify}
//         />
//       )}
//     </>
//   );
// };

// /* ═══════════════════════════════════════════
//    Main Splitbills Component
// ═══════════════════════════════════════════ */
// const Splitbills = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const state = location.state || {};

//   const {
//     invoiceId,
//     invoiceNumber,
//     subTotal: invoiceSubTotal = 0,
//     billTo,
//     releaseOrder,
//     selectedBank: invoiceSelectedBank = null,
//     selectedQuery: invoiceSelectedQuery = null,
//   } = state;

//   const bankId = releaseOrder?.client?._id || releaseOrder?.client;
//   const clientName =
//     billTo?.company || releaseOrder?.client?.bankName || "Client";

//   const [branches, setBranches] = useState([]);
//   const [branchLoading, setBranchLoading] = useState(false);
//   const [groups, setGroups] = useState([newBranchGroup()]);
//   const [saving, setSaving] = useState(false);
//   const [toast, setToast] = useState(null);
//   const [showSummary, setShowSummary] = useState(false);
//   const [existingSplitBills, setExistingSplitBills] = useState([]);
//   const [existingSplitBillType, setExistingSplitBillType] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [bankList, setBankList] = useState([]);
//   const [queryList, setQueryList] = useState([]);
//   const [selectedBank, setSelectedBank] = useState(null);
//   const [selectedQuery, setSelectedQuery] = useState(null);

//   const notify = (message, type = "success") => setToast({ message, type });

//   /* ── Fetch branches ── */
//   const fetchBranches = () => {
//     if (!bankId) return;
//     setBranchLoading(true);
//     axios
//       .get(`${BASE_URL}/branch/get-branches-by-bank/${bankId}`)
//       .then((res) => setBranches(res.data?.data || []))
//       .catch(() => notify("Failed to load sub-clients", "error"))
//       .finally(() => setBranchLoading(false));
//   };

//   useEffect(() => {
//     fetchBranches();
//   }, [bankId]);

//   /* ── Called when a new sub-client is created inline ── */
//   const handleBranchCreated = (newBranch, groupIdx) => {
//     // Add to local branches list immediately
//     setBranches((prev) => {
//       const exists = prev.find((b) => b._id === newBranch._id);
//       return exists ? prev : [...prev, newBranch];
//     });
//     // Auto-select the new sub-client in the group that triggered the modal
//     setGroups((g) =>
//       g.map((grp, i) =>
//         i === groupIdx
//           ? {
//               ...grp,
//               branchId: newBranch._id,
//               branchName: newBranch.branchName,
//             }
//           : grp,
//       ),
//     );
//     notify(`Sub-client "${newBranch.branchName}" created & selected`);
//   };

//   useEffect(() => {
//     axios
//       .get(`${BASE_URL}/company/get`)
//       .then((res) => {
//         const company = res.data?.data || res.data;
//         const banks = company?.bankDetails || [];
//         const queries = company?.queryDetails || [];
//         setBankList(banks);
//         setQueryList(queries);
//         setSelectedBank(
//           invoiceSelectedBank || (banks.length ? banks[0] : null),
//         );
//         setSelectedQuery(
//           invoiceSelectedQuery || (queries.length ? queries[0] : null),
//         );
//       })
//       .catch(() => notify("Failed to load company details", "error"));
//   }, []);
//   useEffect(() => {
//     if (!invoiceId) return;
//     setLoading(true);
//     axios
//       .get(`${BASE_URL}/splitsbill/${invoiceId}/split-bills`)
//       .then((res) => {
//         const data = res.data?.data;
//         const splits = data?.splitBills || [];
//         const splitType = data?.splitBillType || "branch";

//         if (splits.length) {
//           setExistingSplitBills(splits);
//           setExistingSplitBillType(splitType);

//           // Populate the form with existing data
//           if (splits[0]?.selectedBank) setSelectedBank(splits[0].selectedBank);
//           if (splits[0]?.selectedQuery)
//             setSelectedQuery(splits[0].selectedQuery);

//           const map = new Map();
//           splits.forEach((s) => {
//             const bid = s.branch?._id || s.branch || "__none__";
//             if (!map.has(bid)) {
//               map.set(bid, {
//                 id: crypto.randomUUID(),
//                 branchId: bid === "__none__" ? "" : bid,
//                 branchName: s.branchName || "",
//                 borrowers: [],
//               });
//             }
//             map.get(bid).borrowers.push({
//               id: crypto.randomUUID(),
//               borrowersName: s.borrowersName || "",
//               perAcc: s.perAcc || "",
//               acc: s.acc || 1,
//             });
//           });
//           setGroups([...map.values()]);
//         }
//       })
//       .catch((err) => {
//         console.error("Failed to load split bills:", err);
//       })
//       .finally(() => setLoading(false));
//   }, [invoiceId]);

//   const addGroup = () => setGroups((g) => [...g, newBranchGroup()]);

//   const updateGroup = (gIdx, patch) =>
//     setGroups((g) =>
//       g.map((grp, i) => (i === gIdx ? { ...grp, ...patch } : grp)),
//     );

//   const removeGroup = (gIdx) =>
//     setGroups((g) => g.filter((_, i) => i !== gIdx));

//   const addBorrower = (gIdx) =>
//     setGroups((g) =>
//       g.map((grp, i) =>
//         i === gIdx
//           ? { ...grp, borrowers: [...grp.borrowers, newBorrower()] }
//           : grp,
//       ),
//     );

//   const updateBorrower = (gIdx, bIdx, patch) =>
//     setGroups((g) =>
//       g.map((grp, i) =>
//         i === gIdx
//           ? {
//               ...grp,
//               borrowers: grp.borrowers.map((b, j) =>
//                 j === bIdx ? { ...b, ...patch } : b,
//               ),
//             }
//           : grp,
//       ),
//     );

//   const removeBorrower = (gIdx, bIdx) =>
//     setGroups((g) =>
//       g.map((grp, i) =>
//         i === gIdx
//           ? { ...grp, borrowers: grp.borrowers.filter((_, j) => j !== bIdx) }
//           : grp,
//       ),
//     );

//   const allocatedSubTotal = groups.reduce(
//     (s, g) => s + g.borrowers.reduce((ss, b) => ss + getBorrowerSubTotal(b), 0),
//     0,
//   );

//   const allocatedTotal = groups.reduce((s, g) => {
//     const groupSub = g.borrowers.reduce(
//       (ss, b) => ss + getBorrowerSubTotal(b),
//       0,
//     );
//     return s + calcGST(groupSub).total;
//   }, 0);

//   const totalBorrowers = groups.reduce((s, g) => s + g.borrowers.length, 0);
//   const isBalanced = Math.abs(invoiceSubTotal - allocatedSubTotal) < 0.005;

//   const handleSave = async () => {
//     for (let gi = 0; gi < groups.length; gi++) {
//       const g = groups[gi];
//       if (!g.branchId) {
//         notify(`Sub-client ${gi + 1}: Please select a sub-client`, "error");
//         return;
//       }
//       for (let bi = 0; bi < g.borrowers.length; bi++) {
//         const b = g.borrowers[bi];
//         if (!b.borrowersName?.trim()) {
//           notify(
//             `Sub-client ${gi + 1}, Borrower ${bi + 1}: Name is required`,
//             "error",
//           );
//           return;
//         }
//       }
//     }

//     if (!isBalanced) {
//       notify("Total allocated must equal invoice sub total", "error");
//       return;
//     }

//     const splitItems = groups.flatMap((g) =>
//       g.borrowers.map((b) => {
//         const subTotal = getBorrowerSubTotal(b);
//         const { cgst, sgst, total } = calcGST(subTotal);
//         return {
//           branchId: g.branchId,
//           branchName: g.branchName,
//           borrowersName: b.borrowersName,
//           perAcc: Number(b.perAcc),
//           acc: Number(b.acc) || 1,
//           subTotal,
//           cgstAmount: cgst,
//           sgstAmount: sgst,
//           totalAmount: total,
//           selectedBank: selectedBank || null,
//           selectedQuery: selectedQuery || null,
//         };
//       }),
//     );

//     setSaving(true);
//     try {
//       await axios.post(`${BASE_URL}/splitsbill/${invoiceId}/split-bills`, {
//         splitItems,
//       });
//       notify("Split bills saved successfully");
//       setTimeout(() => navigate(-1), 1500);
//     } catch (err) {
//       notify(
//         err?.response?.data?.message || "Failed to save split bills",
//         "error",
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleViewSummary = async () => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/splitsbill/${invoiceId}/split-bills/summary`,
//       );
//       const data = res.data?.data;
//       setExistingSplitBills(data?.splitBills || []);
//       setExistingSplitBillType(data?.splitBillType);
//       setShowSummary(true);
//     } catch (err) {
//       notify("Failed to load split bill summary", "error");
//     }
//   };

//   const handleGeneratePDF = async (splitBillIndex) => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/splitsbill/${invoiceId}/split-bills/${splitBillIndex}/pdf`,
//         {
//           responseType: "blob", // For PDF download
//         },
//       );

//       // Create blob link to download
//       const url = window.URL.createObjectURL(new Blob([res.data]));
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute(
//         "download",
//         `split_bill_${invoiceNumber}_${splitBillIndex + 1}.pdf`,
//       );
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);

//       notify("PDF generated successfully");
//     } catch (err) {
//       notify("Failed to generate PDF", "error");
//     }
//   };

//   const handleDeleteAllSplitBills = async () => {
//     if (
//       !window.confirm(
//         "Are you sure you want to delete all split bills? This action cannot be undone.",
//       )
//     ) {
//       return;
//     }

//     try {
//       await axios.delete(`${BASE_URL}/splitsbill/${invoiceId}/split-bills`);
//       notify("All split bills deleted successfully");
//       // Reset groups
//       setGroups([newBranchGroup()]);
//       setExistingSplitBills([]);
//       setExistingSplitBillType(null);
//     } catch (err) {
//       notify("Failed to delete split bills", "error");
//     }
//   };

//   if (!invoiceId) {
//     return (
//       <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center gap-4 text-slate-400">
//         <RiInboxLine className="w-12 h-12 text-blue-200" />
//         <p className="text-sm font-semibold">No invoice selected.</p>
//         <button
//           onClick={() => navigate(-1)}
//           className="text-xs text-indigo-500 hover:underline flex items-center gap-1"
//         >
//           <RiArrowLeftLine className="w-3.5 h-3.5" /> Go back
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-800">
//       {/* ── Header ── */}
//       <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
//           <div className="flex items-center gap-3">
//             <button
//               onClick={() => navigate(-1)}
//               className="w-9 h-9 rounded-xl border border-blue-100 flex items-center justify-center text-slate-500 hover:bg-blue-50 hover:text-indigo-600 transition"
//             >
//               <RiArrowLeftLine className="w-4 h-4" />
//             </button>
//             <div className="w-10 h-10 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-md shadow-violet-200">
//               <RiSplitCellsHorizontal className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-indigo-800 tracking-tight">
//                 Split Bills
//               </h1>
//               <p className="text-[11px] text-indigo-400 tracking-widest uppercase">
//                 Invoice{" "}
//                 <span className="font-bold text-violet-600">
//                   {invoiceNumber}
//                 </span>
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-3">
//             {/* View Summary Button */}
//             {existingSplitBills.length > 0 && (
//               <button
//                 onClick={handleViewSummary}
//                 className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-bold shadow-md shadow-blue-200 hover:bg-blue-700 transition"
//               >
//                 <RiEyeLine className="w-4 h-4" />
//                 View Summary
//               </button>
//             )}

//             {/* Delete All Button */}
//             {groups.length > 0 && (
//               <button
//                 onClick={handleDeleteAllSplitBills}
//                 className="flex items-center gap-2 px-4 py-2.5 bg-red-600 text-white rounded-xl text-sm font-bold shadow-md shadow-red-200 hover:bg-red-700 transition"
//               >
//                 <RiDeleteBinLine className="w-4 h-4" />
//                 Delete All
//               </button>
//             )}

//             <div className="hidden sm:flex items-center gap-4 bg-blue-50 border border-blue-100 rounded-xl px-4 py-2">
//               <div className="flex flex-col items-end">
//                 <span className="text-[10px] text-slate-400 uppercase tracking-widest">
//                   Bill To
//                 </span>
//                 <span className="text-xs font-bold text-slate-700">
//                   {clientName}
//                 </span>
//               </div>
//               <div className="w-px h-8 bg-blue-200" />
//               <div className="flex flex-col items-end">
//                 <span className="text-[10px] text-slate-400 uppercase tracking-widest">
//                   Sub Total
//                 </span>
//                 <span className="text-xs font-bold text-indigo-700 font-mono">
//                   ₹{fmt(invoiceSubTotal)}
//                 </span>
//               </div>
//             </div>

//             <button
//               onClick={handleSave}
//               disabled={saving || !isBalanced || groups.length === 0}
//               className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold shadow-md shadow-indigo-200 hover:bg-indigo-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {saving ? (
//                 <Spinner className="w-4 h-4" />
//               ) : (
//                 <RiSaveLine className="w-4 h-4" />
//               )}
//               {saving ? "Saving…" : "Save Split Bills"}
//             </button>
//           </div>
//         </div>
//       </header>

//       <div className="px-6 py-6 space-y-5 w-full">
//         {/* ── Info cards ── */}
//         <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//           <div className="bg-white border border-blue-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-blue-50 flex items-center justify-center">
//               <RiFileTextLine className="w-4 h-4 text-indigo-600" />
//             </div>
//             <div>
//               <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
//                 Invoice
//               </div>
//               <div className="text-sm font-bold text-indigo-700 font-mono">
//                 {invoiceNumber}
//               </div>
//             </div>
//           </div>
//           <div className="bg-white border border-blue-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-violet-50 flex items-center justify-center">
//               <RiBuilding2Line className="w-4 h-4 text-violet-600" />
//             </div>
//             <div>
//               <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
//                 Client
//               </div>
//               <div className="text-sm font-bold text-slate-700 truncate max-w-[180px]">
//                 {clientName}
//               </div>
//             </div>
//           </div>
//           <div className="bg-white border border-blue-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
//             <div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center">
//               <LiaRupeeSignSolid className="w-4 h-4 text-emerald-600" />
//             </div>
//             <div>
//               <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
//                 Invoice Sub Total
//               </div>
//               <div className="text-sm font-bold text-emerald-700 font-mono">
//                 ₹{fmt(invoiceSubTotal)}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ── Summary bar ── */}
//         <SummaryBar
//           invoiceSubTotal={invoiceSubTotal}
//           allocatedSubTotal={allocatedSubTotal}
//           allocatedTotal={allocatedTotal}
//           branchCount={groups.length}
//           borrowerCount={totalBorrowers}
//         />

//         {/* ── Global Payment & Contact Details ── */}
//         <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
//           <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
//             <div className="flex items-center gap-2">
//               <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
//                 <RiBankLine className="w-3 h-3" />
//               </span>
//               <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
//                 Payment & Contact Details
//               </span>
//             </div>
//             <span className="text-[10px] text-indigo-400 bg-indigo-50 border border-indigo-100 px-2 py-0.5 rounded-full font-semibold">
//               Applies to entire split bill
//             </span>
//           </div>

//           <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
//             {/* Bank Account */}
//             <div>
//               <label className="text-[10px] font-bold text-blue-600 uppercase tracking-widest mb-1.5 block">
//                 Bank Account
//               </label>
//               {bankList.length === 0 ? (
//                 <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700">
//                   <RiErrorWarningLine className="w-4 h-4 flex-shrink-0" />
//                   No bank accounts found. Add one in Company Settings.
//                 </div>
//               ) : (
//                 <select
//                   value={
//                     selectedBank
//                       ? JSON.stringify({
//                           accountNumber: selectedBank.accountNumber,
//                           ifscCode: selectedBank.ifscCode,
//                           branchName: selectedBank.branchName,
//                           branchAddress: selectedBank.branchAddress,
//                         })
//                       : ""
//                   }
//                   onChange={(e) =>
//                     setSelectedBank(
//                       e.target.value ? JSON.parse(e.target.value) : null,
//                     )
//                   }
//                   className={inputCls}
//                 >
//                   <option value="">— Select bank account —</option>
//                   {bankList.map((bank, i) => (
//                     <option
//                       key={i}
//                       value={JSON.stringify({
//                         accountNumber: bank.accountNumber,
//                         ifscCode: bank.ifscCode,
//                         branchName: bank.branchName,
//                         branchAddress: bank.branchAddress,
//                       })}
//                     >
//                       {bank.branchName ? `${bank.branchName} — ` : ""}
//                       {bank.accountNumber}
//                     </option>
//                   ))}
//                 </select>
//               )}

//               {selectedBank && (
//                 <div className="mt-2 rounded-xl border border-blue-100 bg-blue-50/40 overflow-hidden">
//                   <div className="flex items-center gap-2 px-3 py-1.5 border-b border-blue-100 bg-blue-50">
//                     <RiBankLine className="w-3 h-3 text-blue-500 flex-shrink-0" />
//                     <span className="text-[9px] font-bold text-blue-600 uppercase tracking-widest">
//                       Selected Bank
//                     </span>
//                   </div>
//                   <div className="px-3 py-2 space-y-1">
//                     {selectedBank.branchName && (
//                       <div className="flex justify-between text-xs">
//                         <span className="text-slate-400">Branch</span>
//                         <span className="text-slate-700 font-semibold">
//                           {selectedBank.branchName}
//                         </span>
//                       </div>
//                     )}
//                     <div className="flex justify-between text-xs">
//                       <span className="text-slate-400">Account No.</span>
//                       <span className="text-slate-700 font-semibold font-mono">
//                         {selectedBank.accountNumber}
//                       </span>
//                     </div>
//                     <div className="flex justify-between text-xs">
//                       <span className="text-slate-400">IFSC</span>
//                       <span className="text-slate-700 font-semibold font-mono">
//                         {selectedBank.ifscCode}
//                       </span>
//                     </div>
//                     {selectedBank.branchAddress && (
//                       <div className="flex justify-between text-xs gap-4">
//                         <span className="text-slate-400 flex-shrink-0">
//                           Address
//                         </span>
//                         <span className="text-slate-700 text-right">
//                           {selectedBank.branchAddress}
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Query Contact */}
//             <div>
//               <label className="text-[10px] font-bold text-blue-600 uppercase tracking-widest mb-1.5 block">
//                 Query Contact
//               </label>
//               {queryList.length === 0 ? (
//                 <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700">
//                   <RiErrorWarningLine className="w-4 h-4 flex-shrink-0" />
//                   No query contacts found. Add one in Company Settings.
//                 </div>
//               ) : (
//                 <select
//                   value={
//                     selectedQuery
//                       ? JSON.stringify({
//                           contactPersonName: selectedQuery.contactPersonName,
//                           phone: selectedQuery.phone,
//                         })
//                       : ""
//                   }
//                   onChange={(e) =>
//                     setSelectedQuery(
//                       e.target.value ? JSON.parse(e.target.value) : null,
//                     )
//                   }
//                   className={inputCls}
//                 >
//                   <option value="">— Select query contact —</option>
//                   {queryList.map((q, i) => (
//                     <option
//                       key={i}
//                       value={JSON.stringify({
//                         contactPersonName: q.contactPersonName,
//                         phone: q.phone,
//                       })}
//                     >
//                       {q.contactPersonName}
//                       {q.phone ? ` — ${q.phone}` : ""}
//                     </option>
//                   ))}
//                 </select>
//               )}

//               {selectedQuery && (
//                 <div className="mt-2 rounded-xl border border-blue-100 bg-blue-50/40 overflow-hidden">
//                   <div className="flex items-center gap-2 px-3 py-1.5 border-b border-blue-100 bg-blue-50">
//                     <RiPhoneLine className="w-3 h-3 text-blue-500 flex-shrink-0" />
//                     <span className="text-[9px] font-bold text-blue-600 uppercase tracking-widest">
//                       Selected Contact
//                     </span>
//                   </div>
//                   <div className="px-3 py-2 space-y-1">
//                     {selectedQuery.contactPersonName && (
//                       <div className="flex justify-between text-xs">
//                         <span className="text-slate-400">Name</span>
//                         <span className="text-slate-700 font-semibold">
//                           {selectedQuery.contactPersonName}
//                         </span>
//                       </div>
//                     )}
//                     {selectedQuery.phone && (
//                       <div className="flex justify-between text-xs">
//                         <span className="text-slate-400">Phone</span>
//                         <span className="text-slate-700 font-semibold font-mono">
//                           {selectedQuery.phone}
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="space-y-4">
//           {groups.length === 0 ? (
//             <div className="bg-white border border-blue-100 rounded-2xl shadow-sm flex flex-col items-center justify-center py-16 gap-3 text-slate-400">
//               <RiInboxLine className="w-10 h-10 text-blue-200" />
//               <p className="text-sm font-semibold">No sub-clients added yet.</p>
//               <button
//                 onClick={addGroup}
//                 className="text-xs text-indigo-500 hover:underline flex items-center gap-1"
//               >
//                 <RiAddLine className="w-3.5 h-3.5" /> Add a sub-client
//               </button>
//             </div>
//           ) : (
//             groups.map((group, gIdx) => (
//               <BranchGroup
//                 key={group.id}
//                 group={group}
//                 groupIdx={gIdx}
//                 branches={branches}
//                 bankId={bankId}
//                 clientName={clientName}
//                 onUpdateGroup={updateGroup}
//                 onRemoveGroup={removeGroup}
//                 onAddBorrower={addBorrower}
//                 onUpdateBorrower={updateBorrower}
//                 onRemoveBorrower={removeBorrower}
//                 onBranchCreated={handleBranchCreated}
//                 notify={notify}
//               />
//             ))
//           )}
//         </div>

//         <button
//           onClick={addGroup}
//           className="w-full flex items-center justify-center gap-2 py-3 border-2 border-dashed border-indigo-200 text-indigo-500 rounded-2xl text-sm font-semibold hover:border-indigo-400 hover:bg-indigo-50/50 transition"
//         >
//           {branchLoading ? (
//             <Spinner className="w-4 h-4" />
//           ) : (
//             <RiAddLine className="w-4 h-4" />
//           )}
//           Add Sub-client Row
//         </button>

//         <div className="flex items-center justify-between gap-4 flex-wrap pt-2">
//           <button
//             onClick={() => navigate(-1)}
//             className="flex items-center gap-2 px-5 py-2.5 border border-slate-200 text-slate-600 rounded-xl text-sm font-semibold hover:bg-slate-50 transition"
//           >
//             <RiArrowLeftLine className="w-4 h-4" />
//             Back to Invoices
//           </button>

//           <div className="flex items-center gap-3">
//             {!isBalanced && groups.length > 0 && (
//               <span className="text-xs text-amber-600 font-semibold">
//                 {allocatedSubTotal > invoiceSubTotal
//                   ? `Over by ₹${fmt(allocatedSubTotal - invoiceSubTotal)}`
//                   : `₹${fmt(invoiceSubTotal - allocatedSubTotal)} remaining to allocate`}
//               </span>
//             )}
//             <button
//               onClick={handleSave}
//               disabled={saving || !isBalanced || groups.length === 0}
//               className="flex items-center gap-2 px-6 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold shadow-md shadow-indigo-200 hover:bg-indigo-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
//             >
//               {saving ? (
//                 <Spinner className="w-4 h-4" />
//               ) : (
//                 <RiSaveLine className="w-4 h-4" />
//               )}
//               {saving ? "Saving…" : "Save Split Bills"}
//             </button>
//           </div>
//         </div>
//       </div>

//       {showSummary && (
//         <SplitBillSummaryModal
//           invoice={{ invoiceNumber }}
//           splitBills={existingSplitBills}
//           splitBillType={existingSplitBillType}
//           onClose={() => setShowSummary(false)}
//         />
//       )}

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// };

// export default Splitbills;

import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  RiArrowLeftLine,
  RiAddLine,
  RiDeleteBinLine,
  RiCheckLine,
  RiCloseLine,
  RiErrorWarningLine,
  RiSplitCellsHorizontal,
  RiBuilding2Line,
  RiBankLine,
  RiFileTextLine,
  RiSaveLine,
  RiInboxLine,
  RiUserAddLine,
  RiUserLine,
  RiPhoneLine,
  RiMapPinLine,
  RiMailLine,
  RiHashtag,
  RiEyeLine,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { LiaRupeeSignSolid } from "react-icons/lia";
import { FaCodeBranch } from "react-icons/fa";

const BASE_URL = process.env.REACT_APP_API_URL;

const Spinner = ({ className = "w-4 h-4" }) => (
  <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
);

const fmt = (n) =>
  Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const calcGST = (subTotal, cgstRate = 2.5, sgstRate = 2.5) => {
  const s = Number(subTotal) || 0;
  const cgst = parseFloat(((s * cgstRate) / 100).toFixed(2));
  const sgst = parseFloat(((s * sgstRate) / 100).toFixed(2));
  const total = parseFloat((s + cgst + sgst).toFixed(2));
  return { cgst, sgst, total };
};

const getBorrowerSubTotal = (b) =>
  parseFloat(
    ((Number(b.perAccount) || 0) * (Number(b.accountNumber) || 1)).toFixed(2),
  );

// Updated borrower structure to match schema
const newBorrower = () => ({
  id: crypto.randomUUID(),
  borrowerName: "", // Changed from borrowersName
  perAccount: "", // Changed from perAcc
  accountNumber: 1, // Changed from acc
});

const newBranchGroup = () => ({
  id: crypto.randomUUID(),
  branchId: "",
  branchName: "",
  borrowers: [newBorrower()],
});

const inputCls =
  "w-full bg-blue-50/60 border border-blue-200 rounded-xl px-3 py-2 text-xs text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition";

/* ─── Toast ─── */
const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [onClose]);
  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${
        type === "success"
          ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
          : "bg-red-50 border border-red-200 text-red-800"
      }`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button onClick={onClose} className="ml-2 opacity-50 hover:opacity-100">
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

/* ─── Split Bill Summary Modal ─── */
const SplitBillSummaryModal = ({
  invoice,
  splitBills,
  splitBillType,
  onClose,
}) => {
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-4xl mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-gradient-to-r from-blue-50 to-violet-50 flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-md shadow-violet-200">
              <RiFileTextLine className="w-4 h-4" />
            </div>
            <div>
              <h2 className="text-sm font-bold text-blue-900">
                Split Bill Summary
              </h2>
              <p className="text-[11px] text-blue-400 font-medium">
                Invoice: {invoice?.invoiceNumber}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
          >
            <RiCloseLine className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto flex-1">
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
            <div className="bg-blue-50 rounded-xl p-3 text-center">
              <div className="text-[10px] text-blue-600 uppercase font-bold">
                Total Split Bills
              </div>
              <div className="text-2xl font-bold text-blue-800">
                {splitBills?.length || 0}
              </div>
            </div>
            <div className="bg-indigo-50 rounded-xl p-3 text-center">
              <div className="text-[10px] text-indigo-600 uppercase font-bold">
                Total Sub Total
              </div>
              <div className="text-2xl font-bold text-indigo-800">
                ₹{fmt(splitBills?.reduce((s, b) => s + b.subTotal, 0) || 0)}
              </div>
            </div>
            <div className="bg-violet-50 rounded-xl p-3 text-center">
              <div className="text-[10px] text-violet-600 uppercase font-bold">
                Total GST
              </div>
              <div className="text-2xl font-bold text-violet-800">
                ₹
                {fmt(
                  splitBills?.reduce(
                    (s, b) => s + (b.cgst || 0) + (b.sgst || 0),
                    0,
                  ) || 0,
                )}
              </div>
            </div>
            <div className="bg-emerald-50 rounded-xl p-3 text-center">
              <div className="text-[10px] text-emerald-600 uppercase font-bold">
                Total Amount
              </div>
              <div className="text-2xl font-bold text-emerald-800">
                ₹{fmt(splitBills?.reduce((s, b) => s + b.total, 0) || 0)}
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-blue-100 bg-slate-50">
                  <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-400 uppercase">
                    #
                  </th>
                  <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-400 uppercase">
                    Sub-client
                  </th>
                  <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-400 uppercase">
                    Borrower
                  </th>
                  <th className="px-4 py-2 text-right text-[10px] font-semibold text-slate-400 uppercase">
                    Sub Total
                  </th>
                  <th className="px-4 py-2 text-right text-[10px] font-semibold text-slate-400 uppercase">
                    CGST
                  </th>
                  <th className="px-4 py-2 text-right text-[10px] font-semibold text-slate-400 uppercase">
                    SGST
                  </th>
                  <th className="px-4 py-2 text-right text-[10px] font-semibold text-slate-400 uppercase">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {splitBills?.map((bill, idx) => (
                  <tr
                    key={idx}
                    className="border-b border-slate-50 hover:bg-blue-50/20"
                  >
                    <td className="px-4 py-3 text-xs text-slate-500 font-mono">
                      {idx + 1}
                    </td>
                    <td className="px-4 py-3 text-xs font-semibold text-slate-700">
                      {bill.branchName}
                    </td>
                    <td className="px-4 py-3 text-xs text-slate-600">
                      {bill.borrowers
                        ? bill.borrowers.map((b) => b.borrowerName).join(", ")
                        : bill.borrowersName}
                    </td>
                    <td className="px-4 py-3 text-right text-xs font-mono text-slate-700">
                      ₹{fmt(bill.subTotal)}
                    </td>
                    <td className="px-4 py-3 text-right text-xs font-mono text-slate-600">
                      ₹{fmt(bill.cgst)}
                    </td>
                    <td className="px-4 py-3 text-right text-xs font-mono text-slate-600">
                      ₹{fmt(bill.sgst)}
                    </td>
                    <td className="px-4 py-3 text-right text-xs font-mono font-bold text-indigo-700">
                      ₹{fmt(bill.total)}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-slate-50 border-t border-blue-100">
                <tr>
                  <td
                    colSpan={3}
                    className="px-4 py-3 text-xs font-bold text-slate-600"
                  >
                    Total
                  </td>
                  <td className="px-4 py-3 text-right text-xs font-bold font-mono text-slate-800">
                    ₹{fmt(splitBills?.reduce((s, b) => s + b.subTotal, 0))}
                  </td>
                  <td className="px-4 py-3 text-right text-xs font-bold font-mono text-slate-800">
                    ₹{fmt(splitBills?.reduce((s, b) => s + (b.cgst || 0), 0))}
                  </td>
                  <td className="px-4 py-3 text-right text-xs font-bold font-mono text-slate-800">
                    ₹{fmt(splitBills?.reduce((s, b) => s + (b.sgst || 0), 0))}
                  </td>
                  <td className="px-4 py-3 text-right text-xs font-bold font-mono text-indigo-800">
                    ₹{fmt(splitBills?.reduce((s, b) => s + b.total, 0))}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-blue-50 bg-slate-50/50 flex-shrink-0">
          <button
            onClick={onClose}
            className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
          >
            <RiCloseLine className="w-4 h-4" /> Close
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

/* ─── Add Sub-client Modal ─── */
const defaultSubClientForm = {
  branchName: "",
  contactPerson: "",
  phone: "",
  email: "",
  address: "",
  pin: "",
};

const subClientFields = [
  {
    label: "Sub-client Name",
    name: "branchName",
    icon: FaCodeBranch,
    required: true,
  },
  { label: "Contact Person", name: "contactPerson", icon: RiUserLine },
  { label: "Phone", name: "phone", icon: RiPhoneLine, type: "tel" },
  { label: "Email", name: "email", icon: RiMailLine, type: "email" },
  { label: "Address", name: "address", icon: RiMapPinLine },
  { label: "PIN", name: "pin", icon: RiHashtag },
];

const SubClientModal = ({ bankId, clientName, onClose, onCreated, notify }) => {
  const [form, setForm] = useState(defaultSubClientForm);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleCreate = async () => {
    if (!form.branchName.trim()) {
      notify("Sub-client name is required", "error");
      return;
    }
    if (!bankId) {
      notify("No client ID found for this invoice", "error");
      return;
    }
    setSaving(true);
    try {
      const res = await axios.post(`${BASE_URL}/branch/create-branch`, {
        ...form,
        bankId,
      });
      const created = res.data?.data || res.data;
      notify("Sub-client created successfully");
      onCreated(created);
    } catch (err) {
      notify(
        err?.response?.data?.message || "Failed to create sub-client",
        "error",
      );
    } finally {
      setSaving(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-lg mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-gradient-to-r from-blue-50 to-violet-50">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-md shadow-violet-200">
              <FaCodeBranch className="w-4 h-4" />
            </div>
            <div>
              <h2 className="text-sm font-bold text-blue-900">
                Add Sub-client
              </h2>
              {clientName && (
                <p className="text-[11px] text-blue-400 font-medium">
                  Under:{" "}
                  <span className="text-violet-600 font-bold">
                    {clientName}
                  </span>
                </p>
              )}
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
          >
            <RiCloseLine className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            {subClientFields.map(
              ({ label, name, icon: Icon, type = "text", required }) => (
                <div
                  key={name}
                  className={name === "address" ? "col-span-2" : "col-span-1"}
                >
                  <label className="text-[10px] font-bold text-blue-600 uppercase tracking-widest mb-1.5 block">
                    {label}
                    {required && <span className="text-red-400 ml-0.5">*</span>}
                  </label>
                  <div className="relative">
                    <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-blue-300 pointer-events-none" />
                    <input
                      type={type}
                      name={name}
                      value={form[name]}
                      onChange={handleChange}
                      placeholder={label}
                      className="w-full bg-blue-50/60 border border-blue-200 rounded-xl pl-8 pr-3 py-2 text-xs text-slate-800 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
                    />
                  </div>
                </div>
              ),
            )}
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-blue-50 bg-slate-50/50">
          <button
            onClick={onClose}
            className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm text-slate-500 hover:text-slate-700 border border-slate-200 hover:bg-slate-50 transition"
          >
            <RiCloseLine className="w-4 h-4" /> Cancel
          </button>
          <button
            onClick={handleCreate}
            disabled={saving}
            className="flex items-center gap-2 px-5 py-2 rounded-xl text-sm font-bold bg-violet-600 hover:bg-violet-700 text-white transition shadow-md shadow-violet-200 disabled:opacity-60"
          >
            {saving ? <Spinner /> : <RiCheckLine className="w-4 h-4" />}
            {saving ? "Creating…" : "Create Sub-client"}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

/* ─── Summary Bar ─── */
const SummaryBar = ({
  invoiceSubTotal,
  allocatedSubTotal,
  allocatedTotal,
  branchCount,
  borrowerCount,
}) => {
  const remaining = invoiceSubTotal - allocatedSubTotal;
  const isOver = remaining < -0.005;
  const isBalanced = Math.abs(remaining) < 0.005;

  return (
    <div className="bg-white border border-blue-100 rounded-2xl shadow-sm px-6 py-4 flex flex-wrap items-center gap-6">
      <div className="flex flex-col">
        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
          Invoice Sub Total
        </span>
        <span className="text-lg font-extrabold text-slate-800 font-mono">
          ₹{fmt(invoiceSubTotal)}
        </span>
      </div>
      <div className="h-8 w-px bg-slate-100" />
      <div className="flex flex-col">
        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
          Allocated Sub Total ({branchCount} sub-client
          {branchCount !== 1 ? "s" : ""}, {borrowerCount} borrower
          {borrowerCount !== 1 ? "s" : ""})
        </span>
        <span className="text-lg font-extrabold text-indigo-700 font-mono">
          ₹{fmt(allocatedSubTotal)}
        </span>
      </div>
      <div className="h-8 w-px bg-slate-100" />
      <div className="flex flex-col">
        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
          Allocated Grand Total (with GST)
        </span>
        <span className="text-lg font-extrabold text-violet-700 font-mono">
          ₹{fmt(allocatedTotal)}
        </span>
      </div>
      <div className="h-8 w-px bg-slate-100" />
      <div className="flex flex-col">
        <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">
          Remaining (Sub Total)
        </span>
        <span
          className={`text-lg font-extrabold font-mono ${
            isBalanced
              ? "text-emerald-600"
              : isOver
                ? "text-red-600"
                : "text-amber-600"
          }`}
        >
          ₹{fmt(Math.abs(remaining))}
          {isOver ? " (over)" : isBalanced ? " ✓" : ""}
        </span>
      </div>
      <div className="ml-auto">
        {isBalanced ? (
          <span className="flex items-center gap-1.5 text-xs font-bold text-emerald-600 bg-emerald-50 border border-emerald-200 px-3 py-1.5 rounded-lg">
            <RiCheckLine className="w-3.5 h-3.5" />
            Balanced
          </span>
        ) : isOver ? (
          <span className="flex items-center gap-1.5 text-xs font-bold text-red-600 bg-red-50 border border-red-200 px-3 py-1.5 rounded-lg">
            <RiErrorWarningLine className="w-3.5 h-3.5" />
            Over-allocated
          </span>
        ) : (
          <span className="flex items-center gap-1.5 text-xs font-bold text-amber-600 bg-amber-50 border border-amber-200 px-3 py-1.5 rounded-lg">
            <RiErrorWarningLine className="w-3.5 h-3.5" />
            Not balanced
          </span>
        )}
      </div>
    </div>
  );
};

/* ─── Branch Group (Updated) ─── */
const BranchGroup = ({
  group,
  groupIdx,
  branches,
  bankId,
  clientName,
  onUpdateGroup,
  onRemoveGroup,
  onAddBorrower,
  onUpdateBorrower,
  onRemoveBorrower,
  onBranchCreated,
  notify,
}) => {
  const [showSubClientModal, setShowSubClientModal] = useState(false);

  const groupSubTotal = group.borrowers.reduce(
    (s, b) => s + getBorrowerSubTotal(b),
    0,
  );
  const {
    cgst: groupCgst,
    sgst: groupSgst,
    total: groupTotal,
  } = calcGST(groupSubTotal);

  const handleSubClientCreated = (newBranch) => {
    onBranchCreated(newBranch, groupIdx);
    setShowSubClientModal(false);
  };

  return (
    <>
      <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
        <div className="flex items-center gap-3 px-5 py-3.5 bg-blue-50/40 border-b border-blue-100 flex-wrap">
          <div className="w-7 h-7 rounded-lg bg-indigo-100 flex items-center justify-center flex-shrink-0">
            <FaCodeBranch className="w-3.5 h-3.5 text-indigo-600" />
          </div>

          <select
            value={group.branchId}
            onChange={(e) => {
              const selected = branches.find((b) => b._id === e.target.value);
              onUpdateGroup(groupIdx, {
                branchId: e.target.value,
                branchName: selected?.branchName || "",
              });
            }}
            className="flex-1 min-w-[180px] px-3 py-1.5 bg-white border border-blue-200 rounded-xl text-sm font-semibold text-slate-700 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
          >
            <option value="">— Select Sub-client —</option>
            {branches.map((b) => (
              <option key={b._id} value={b._id}>
                {b.branchName}
              </option>
            ))}
          </select>

          <button
            onClick={() => setShowSubClientModal(true)}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-violet-50 border border-violet-200 text-violet-700 rounded-xl text-xs font-bold hover:bg-violet-100 transition flex-shrink-0"
            title="Create a new sub-client"
          >
            <FaCodeBranch className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Add Sub-client</span>
          </button>

          <div className="hidden sm:flex items-center gap-3 bg-white border border-indigo-100 rounded-xl px-4 py-1.5 text-xs font-mono flex-shrink-0">
            <span className="text-slate-400">Sub</span>
            <span className="font-bold text-indigo-700">
              ₹{fmt(groupSubTotal)}
            </span>
            <span className="text-slate-300">|</span>
            <span className="text-slate-400">Total</span>
            <span className="font-bold text-indigo-800">
              ₹{fmt(groupTotal)}
            </span>
          </div>

          <button
            onClick={() => onAddBorrower(groupIdx)}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 border border-blue-200 text-blue-700 rounded-xl text-xs font-bold hover:bg-blue-100 transition flex-shrink-0"
          >
            <RiUserAddLine className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">Add Borrower</span>
          </button>

          <button
            onClick={() => onRemoveGroup(groupIdx)}
            className="w-8 h-8 flex items-center justify-center rounded-lg border border-red-100 text-red-300 hover:text-red-600 hover:bg-red-50 hover:border-red-200 transition flex-shrink-0"
            title="Remove sub-client"
          >
            <RiDeleteBinLine className="w-4 h-4" />
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-blue-50 bg-slate-50/60">
                {[
                  "#",
                  "Borrower's Name",
                  "Per A/C (₹)",
                  "A/C No.",
                  "Sub Total (₹)",
                  "CGST (2.5%)",
                  "SGST (2.5%)",
                  "Total (₹)",
                  "",
                ].map((h) => (
                  <th
                    key={h}
                    className="px-4 py-2.5 text-left text-[10px] font-semibold text-slate-400 uppercase tracking-widest whitespace-nowrap"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {group.borrowers.map((b, bIdx) => {
                const subTotal = getBorrowerSubTotal(b);
                const { cgst, sgst, total } = calcGST(subTotal);
                return (
                  <tr
                    key={b.id}
                    className="border-b border-slate-50 hover:bg-blue-50/10 transition"
                  >
                    <td className="px-4 py-2.5 text-xs text-slate-400 font-mono">
                      {bIdx + 1}
                    </td>
                    <td className="px-3 py-2">
                      <div className="relative">
                        <RiUserLine className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-blue-300 pointer-events-none" />
                        <input
                          type="text"
                          value={b.borrowerName}
                          onChange={(e) =>
                            onUpdateBorrower(groupIdx, bIdx, {
                              borrowerName: e.target.value,
                            })
                          }
                          placeholder="Borrower's name"
                          className="w-full min-w-[160px] pl-8 pr-3 py-2 bg-blue-50/60 border border-blue-200 rounded-xl text-xs text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
                        />
                      </div>
                    </td>
                    <td className="px-3 py-2">
                      <input
                        type="number"
                        value={b.perAccount}
                        onChange={(e) =>
                          onUpdateBorrower(groupIdx, bIdx, {
                            perAccount: e.target.value,
                          })
                        }
                        placeholder="0"
                        step="0.01"
                        min={0}
                        className="w-24 px-3 py-2 bg-blue-50/60 border border-blue-200 rounded-xl text-xs text-slate-700 font-mono placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
                      />
                    </td>
                    <td className="px-3 py-2">
                      <input
                        type="number"
                        value={b.accountNumber}
                        min={1}
                        onChange={(e) =>
                          onUpdateBorrower(groupIdx, bIdx, {
                            accountNumber: e.target.value,
                          })
                        }
                        placeholder="1"
                        className="w-20 px-3 py-2 bg-blue-50/60 border border-blue-200 rounded-xl text-xs text-slate-700 font-mono placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 transition"
                      />
                    </td>
                    <td className="px-4 py-2.5 text-xs font-mono text-slate-700 whitespace-nowrap">
                      <span className="inline-flex items-center gap-1 bg-slate-50 border border-slate-200 rounded-lg px-3 py-1.5 font-bold text-slate-700">
                        ₹{fmt(subTotal)}
                      </span>
                    </td>
                    <td className="px-4 py-2.5 text-xs font-mono text-slate-500 whitespace-nowrap">
                      ₹{fmt(cgst)}
                    </td>
                    <td className="px-4 py-2.5 text-xs font-mono text-slate-500 whitespace-nowrap">
                      ₹{fmt(sgst)}
                    </td>
                    <td className="px-4 py-2.5 whitespace-nowrap">
                      <span className="font-extrabold text-indigo-700 font-mono text-sm">
                        ₹{fmt(total)}
                      </span>
                    </td>
                    <td className="px-4 py-2.5">
                      <button
                        onClick={() => onRemoveBorrower(groupIdx, bIdx)}
                        disabled={group.borrowers.length === 1}
                        className="w-7 h-7 flex items-center justify-center rounded-lg border border-red-100 text-red-300 hover:text-red-600 hover:bg-red-50 hover:border-red-200 transition disabled:opacity-30 disabled:cursor-not-allowed"
                        title="Remove borrower"
                      >
                        <RiCloseLine className="w-3.5 h-3.5" />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>

            {group.borrowers.length > 1 && (
              <tfoot>
                <tr className="bg-indigo-50/50 border-t border-indigo-100">
                  <td
                    colSpan={4}
                    className="px-4 py-2.5 text-[10px] font-bold text-indigo-600 uppercase tracking-widest"
                  >
                    Sub-client Total ({group.borrowers.length} borrowers)
                  </td>
                  <td className="px-4 py-2.5 text-xs font-bold font-mono text-slate-700">
                    ₹{fmt(groupSubTotal)}
                  </td>
                  <td className="px-4 py-2.5 text-xs font-bold font-mono text-slate-700">
                    ₹{fmt(groupCgst)}
                  </td>
                  <td className="px-4 py-2.5 text-xs font-bold font-mono text-slate-700">
                    ₹{fmt(groupSgst)}
                  </td>
                  <td className="px-4 py-2.5">
                    <span className="font-extrabold text-indigo-800 font-mono text-sm">
                      ₹{fmt(groupTotal)}
                    </span>
                  </td>
                  <td />
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>

      {showSubClientModal && (
        <SubClientModal
          bankId={bankId}
          clientName={clientName}
          onClose={() => setShowSubClientModal(false)}
          onCreated={handleSubClientCreated}
          notify={notify}
        />
      )}
    </>
  );
};

/* ═══════════════════════════════════════════
   Main Splitbills Component
═══════════════════════════════════════════ */
const Splitbills = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};

  const {
    invoiceId,
    invoiceNumber,
    subTotal: invoiceSubTotal = 0,
    billTo,
    releaseOrder,
    selectedBank: invoiceSelectedBank = null,
    selectedQuery: invoiceSelectedQuery = null,
  } = state;

  const bankId = releaseOrder?.client?._id || releaseOrder?.client;
  const clientName =
    billTo?.company || releaseOrder?.client?.bankName || "Client";

  const [branches, setBranches] = useState([]);
  const [branchLoading, setBranchLoading] = useState(false);
  const [groups, setGroups] = useState([newBranchGroup()]);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);
  const [showSummary, setShowSummary] = useState(false);
  const [existingSplitBills, setExistingSplitBills] = useState([]);
  const [existingSplitBillType, setExistingSplitBillType] = useState(null);
  const [loading, setLoading] = useState(false);

  const [bankList, setBankList] = useState([]);
  const [queryList, setQueryList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedQuery, setSelectedQuery] = useState(null);

  const notify = (message, type = "success") => setToast({ message, type });

  const fetchBranches = () => {
    if (!bankId) return;
    setBranchLoading(true);
    axios
      .get(`${BASE_URL}/branch/get-branches-by-bank/${bankId}`)
      .then((res) => setBranches(res.data?.data || []))
      .catch(() => notify("Failed to load sub-clients", "error"))
      .finally(() => setBranchLoading(false));
  };

  useEffect(() => {
    fetchBranches();
  }, [bankId]);

  const handleBranchCreated = (newBranch, groupIdx) => {
    setBranches((prev) => {
      const exists = prev.find((b) => b._id === newBranch._id);
      return exists ? prev : [...prev, newBranch];
    });
    setGroups((g) =>
      g.map((grp, i) =>
        i === groupIdx
          ? {
              ...grp,
              branchId: newBranch._id,
              branchName: newBranch.branchName,
            }
          : grp,
      ),
    );
    notify(`Sub-client "${newBranch.branchName}" created & selected`);
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/company/get`)
      .then((res) => {
        const company = res.data?.data || res.data;
        const banks = company?.bankDetails || [];
        const queries = company?.queryDetails || [];
        setBankList(banks);
        setQueryList(queries);
        setSelectedBank(
          invoiceSelectedBank || (banks.length ? banks[0] : null),
        );
        setSelectedQuery(
          invoiceSelectedQuery || (queries.length ? queries[0] : null),
        );
      })
      .catch(() => notify("Failed to load company details", "error"));
  }, []);

  useEffect(() => {
    if (!invoiceId) return;
    setLoading(true);
    axios
      .get(`${BASE_URL}/splitsbill/${invoiceId}/split-bills`)
      .then((res) => {
        const data = res.data?.data;
        const splits = data?.splitBills || [];
        const splitType = data?.splitBillType || "branch";

        if (splits.length) {
          setExistingSplitBills(splits);
          setExistingSplitBillType(splitType);

          if (splits[0]?.selectedBank) setSelectedBank(splits[0].selectedBank);
          if (splits[0]?.selectedQuery)
            setSelectedQuery(splits[0].selectedQuery);

          const map = new Map();
          splits.forEach((s) => {
            const bid = s.branch?._id || s.branch || "__none__";
            if (!map.has(bid)) {
              map.set(bid, {
                id: crypto.randomUUID(),
                branchId: bid === "__none__" ? "" : bid,
                branchName: s.branchName || "",
                borrowers: [],
              });
            }
            // Support both old and new data structure
            if (s.borrowers && Array.isArray(s.borrowers)) {
              // New structure
              s.borrowers.forEach((borrower) => {
                map.get(bid).borrowers.push({
                  id: crypto.randomUUID(),
                  borrowerName: borrower.borrowerName || "",
                  perAccount: borrower.perAccount || borrower.perAcc || "",
                  accountNumber: borrower.accountNumber || borrower.acc || 1,
                });
              });
            } else {
              // Old structure (backward compatibility)
              map.get(bid).borrowers.push({
                id: crypto.randomUUID(),
                borrowerName: s.borrowersName || "",
                perAccount: s.perAcc || "",
                accountNumber: s.acc || 1,
              });
            }
          });
          setGroups([...map.values()]);
        }
      })
      .catch((err) => {
        console.error("Failed to load split bills:", err);
      })
      .finally(() => setLoading(false));
  }, [invoiceId]);

  const addGroup = () => setGroups((g) => [...g, newBranchGroup()]);

  const updateGroup = (gIdx, patch) =>
    setGroups((g) =>
      g.map((grp, i) => (i === gIdx ? { ...grp, ...patch } : grp)),
    );

  const removeGroup = (gIdx) =>
    setGroups((g) => g.filter((_, i) => i !== gIdx));

  const addBorrower = (gIdx) =>
    setGroups((g) =>
      g.map((grp, i) =>
        i === gIdx
          ? { ...grp, borrowers: [...grp.borrowers, newBorrower()] }
          : grp,
      ),
    );

  const updateBorrower = (gIdx, bIdx, patch) =>
    setGroups((g) =>
      g.map((grp, i) =>
        i === gIdx
          ? {
              ...grp,
              borrowers: grp.borrowers.map((b, j) =>
                j === bIdx ? { ...b, ...patch } : b,
              ),
            }
          : grp,
      ),
    );

  const removeBorrower = (gIdx, bIdx) =>
    setGroups((g) =>
      g.map((grp, i) =>
        i === gIdx
          ? { ...grp, borrowers: grp.borrowers.filter((_, j) => j !== bIdx) }
          : grp,
      ),
    );

  const allocatedSubTotal = groups.reduce(
    (s, g) => s + g.borrowers.reduce((ss, b) => ss + getBorrowerSubTotal(b), 0),
    0,
  );

  const allocatedTotal = groups.reduce((s, g) => {
    const groupSub = g.borrowers.reduce(
      (ss, b) => ss + getBorrowerSubTotal(b),
      0,
    );
    return s + calcGST(groupSub).total;
  }, 0);

  const totalBorrowers = groups.reduce((s, g) => s + g.borrowers.length, 0);
  const isBalanced = Math.abs(invoiceSubTotal - allocatedSubTotal) < 0.005;

  // Updated handleSave to match new schema
  const handleSave = async () => {
    for (let gi = 0; gi < groups.length; gi++) {
      const g = groups[gi];
      // if (!g.branchId) {
      //   notify(`Sub-client ${gi + 1}: Please select a sub-client`, "error");
      //   return;
      // }
      for (let bi = 0; bi < g.borrowers.length; bi++) {
        const b = g.borrowers[bi];
        // if (!b.borrowerName?.trim()) {
        //   notify(
        //     `Sub-client ${gi + 1}, Borrower ${bi + 1}: Name is required`,
        //     "error",
        //   );
        //   return;
        // }
        if (!b.perAccount || Number(b.perAccount) <= 0) {
          notify(
            `Sub-client ${gi + 1}, Borrower ${bi + 1}: Per A/C amount is required`,
            "error",
          );
          return;
        }
      }
    }

    if (!isBalanced) {
      notify("Total allocated must equal invoice sub total", "error");
      return;
    }

    // Updated splitItems structure to match controller
    const splitItems = groups.flatMap((g) => {
      // Group borrowers by branch
      const branchBorrowers = g.borrowers.map((b) => {
        const subTotal = getBorrowerSubTotal(b);
        const { cgst, sgst, total } = calcGST(subTotal);
        return {
          borrowerName: b.borrowerName,
          perAccount: Number(b.perAccount),
          accountNumber: Number(b.accountNumber) || 1,
          subtotal: subTotal,
          cgst: cgst,
          sgst: sgst,
          total: total,
        };
      });

      // Calculate branch totals
      const branchSubTotal = branchBorrowers.reduce(
        (sum, b) => sum + b.subtotal,
        0,
      );
      const branchCgst = branchBorrowers.reduce((sum, b) => sum + b.cgst, 0);
      const branchSgst = branchBorrowers.reduce((sum, b) => sum + b.sgst, 0);
      const branchTotal = branchBorrowers.reduce((sum, b) => sum + b.total, 0);

      return [
        {
          branchId: g.branchId,
          branchName: g.branchName,
          borrowers: branchBorrowers,
          branchSubtotal: branchSubTotal,
          branchCgst: branchCgst,
          branchSgst: branchSgst,
          branchTotal: branchTotal,
          selectedBank: selectedBank || null,
          selectedQuery: selectedQuery || null,
        },
      ];
    });

    setSaving(true);
    try {
      await axios.post(`${BASE_URL}/splitsbill/${invoiceId}/split-bills`, {
        splitItems,
      });
      notify("Split bills saved successfully");
      setTimeout(() => navigate(-1), 1500);
    } catch (err) {
      notify(
        err?.response?.data?.message || "Failed to save split bills",
        "error",
      );
    } finally {
      setSaving(false);
    }
  };

  const handleViewSummary = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/splitsbill/${invoiceId}/split-bills/summary`,
      );
      const data = res.data?.data;
      setExistingSplitBills(data?.splitBills || []);
      setExistingSplitBillType(data?.splitBillType);
      setShowSummary(true);
    } catch (err) {
      notify("Failed to load split bill summary", "error");
    }
  };

  if (!invoiceId) {
    return (
      <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center gap-4 text-slate-400">
        <RiInboxLine className="w-12 h-12 text-blue-200" />
        <p className="text-sm font-semibold">No invoice selected.</p>
        <button
          onClick={() => navigate(-1)}
          className="text-xs text-indigo-500 hover:underline flex items-center gap-1"
        >
          <RiArrowLeftLine className="w-3.5 h-3.5" /> Go back
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* Header */}
      <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate(-1)}
              className="w-9 h-9 rounded-xl border border-blue-100 flex items-center justify-center text-slate-500 hover:bg-blue-50 hover:text-indigo-600 transition"
            >
              <RiArrowLeftLine className="w-4 h-4" />
            </button>
            <div className="w-10 h-10 rounded-xl bg-violet-600 flex items-center justify-center text-white shadow-md shadow-violet-200">
              <RiSplitCellsHorizontal className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-indigo-800 tracking-tight">
                Split Bills
              </h1>
              <p className="text-[11px] text-indigo-400 tracking-widest uppercase">
                Invoice{" "}
                <span className="font-bold text-violet-600">
                  {invoiceNumber}
                </span>
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {existingSplitBills.length > 0 && (
              <button
                onClick={handleViewSummary}
                className="flex items-center gap-2 px-4 py-2.5 bg-blue-600 text-white rounded-xl text-sm font-bold shadow-md shadow-blue-200 hover:bg-blue-700 transition"
              >
                <RiEyeLine className="w-4 h-4" />
                View Summary
              </button>
            )}

            <div className="hidden sm:flex items-center gap-4 bg-blue-50 border border-blue-100 rounded-xl px-4 py-2">
              <div className="flex flex-col items-end">
                <span className="text-[10px] text-slate-400 uppercase tracking-widest">
                  Bill To
                </span>
                <span className="text-xs font-bold text-slate-700">
                  {clientName}
                </span>
              </div>
              <div className="w-px h-8 bg-blue-200" />
              <div className="flex flex-col items-end">
                <span className="text-[10px] text-slate-400 uppercase tracking-widest">
                  Sub Total
                </span>
                <span className="text-xs font-bold text-indigo-700 font-mono">
                  ₹{fmt(invoiceSubTotal)}
                </span>
              </div>
            </div>

            <button
              onClick={handleSave}
              disabled={saving || !isBalanced || groups.length === 0}
              className="flex items-center gap-2 px-5 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold shadow-md shadow-indigo-200 hover:bg-indigo-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {saving ? (
                <Spinner className="w-4 h-4" />
              ) : (
                <RiSaveLine className="w-4 h-4" />
              )}
              {saving ? "Saving…" : "Save Split Bills"}
            </button>
          </div>
        </div>
      </header>

      <div className="px-6 py-6 space-y-5 w-full">
        {/* Info cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-white border border-blue-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-blue-50 flex items-center justify-center">
              <RiFileTextLine className="w-4 h-4 text-indigo-600" />
            </div>
            <div>
              <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
                Invoice
              </div>
              <div className="text-sm font-bold text-indigo-700 font-mono">
                {invoiceNumber}
              </div>
            </div>
          </div>
          <div className="bg-white border border-blue-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-violet-50 flex items-center justify-center">
              <RiBuilding2Line className="w-4 h-4 text-violet-600" />
            </div>
            <div>
              <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
                Client
              </div>
              <div className="text-sm font-bold text-slate-700 truncate max-w-[180px]">
                {clientName}
              </div>
            </div>
          </div>
          <div className="bg-white border border-blue-100 rounded-2xl px-5 py-4 shadow-sm flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center">
              <LiaRupeeSignSolid className="w-4 h-4 text-emerald-600" />
            </div>
            <div>
              <div className="text-[10px] text-slate-400 uppercase tracking-widest font-bold">
                Invoice Sub Total
              </div>
              <div className="text-sm font-bold text-emerald-700 font-mono">
                ₹{fmt(invoiceSubTotal)}
              </div>
            </div>
          </div>
        </div>

        {/* Summary bar */}
        <SummaryBar
          invoiceSubTotal={invoiceSubTotal}
          allocatedSubTotal={allocatedSubTotal}
          allocatedTotal={allocatedTotal}
          branchCount={groups.length}
          borrowerCount={totalBorrowers}
        />

        {/* Global Payment & Contact Details */}
        <div className="bg-white border border-blue-100 rounded-2xl shadow-sm overflow-hidden">
          <div className="px-5 py-3 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-5 h-5 rounded-full bg-indigo-600 text-white text-[10px] font-bold flex items-center justify-center flex-shrink-0">
                <RiBankLine className="w-3 h-3" />
              </span>
              <span className="text-xs font-semibold text-blue-700 uppercase tracking-widest">
                Payment & Contact Details
              </span>
            </div>
            <span className="text-[10px] text-indigo-400 bg-indigo-50 border border-indigo-100 px-2 py-0.5 rounded-full font-semibold">
              Applies to entire split bill
            </span>
          </div>

          <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {/* Bank Account */}
            <div>
              <label className="text-[10px] font-bold text-blue-600 uppercase tracking-widest mb-1.5 block">
                Bank Account
              </label>
              {bankList.length === 0 ? (
                <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700">
                  <RiErrorWarningLine className="w-4 h-4 flex-shrink-0" />
                  No bank accounts found. Add one in Company Settings.
                </div>
              ) : (
                <select
                  value={
                    selectedBank
                      ? JSON.stringify({
                          accountNumber: selectedBank.accountNumber,
                          ifscCode: selectedBank.ifscCode,
                          branchName: selectedBank.branchName,
                          branchAddress: selectedBank.branchAddress,
                        })
                      : ""
                  }
                  onChange={(e) =>
                    setSelectedBank(
                      e.target.value ? JSON.parse(e.target.value) : null,
                    )
                  }
                  className={inputCls}
                >
                  <option value="">— Select bank account —</option>
                  {bankList.map((bank, i) => (
                    <option
                      key={i}
                      value={JSON.stringify({
                        accountNumber: bank.accountNumber,
                        ifscCode: bank.ifscCode,
                        branchName: bank.branchName,
                        branchAddress: bank.branchAddress,
                      })}
                    >
                      {bank.branchName ? `${bank.branchName} — ` : ""}
                      {bank.accountNumber}
                    </option>
                  ))}
                </select>
              )}

              {selectedBank && (
                <div className="mt-2 rounded-xl border border-blue-100 bg-blue-50/40 overflow-hidden">
                  <div className="flex items-center gap-2 px-3 py-1.5 border-b border-blue-100 bg-blue-50">
                    <RiBankLine className="w-3 h-3 text-blue-500 flex-shrink-0" />
                    <span className="text-[9px] font-bold text-blue-600 uppercase tracking-widest">
                      Selected Bank
                    </span>
                  </div>
                  <div className="px-3 py-2 space-y-1">
                    {selectedBank.branchName && (
                      <div className="flex justify-between text-xs">
                        <span className="text-slate-400">Branch</span>
                        <span className="text-slate-700 font-semibold">
                          {selectedBank.branchName}
                        </span>
                      </div>
                    )}
                    <div className="flex justify-between text-xs">
                      <span className="text-slate-400">Account No.</span>
                      <span className="text-slate-700 font-semibold font-mono">
                        {selectedBank.accountNumber}
                      </span>
                    </div>
                    <div className="flex justify-between text-xs">
                      <span className="text-slate-400">IFSC</span>
                      <span className="text-slate-700 font-semibold font-mono">
                        {selectedBank.ifscCode}
                      </span>
                    </div>
                    {selectedBank.branchAddress && (
                      <div className="flex justify-between text-xs gap-4">
                        <span className="text-slate-400 flex-shrink-0">
                          Address
                        </span>
                        <span className="text-slate-700 text-right">
                          {selectedBank.branchAddress}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* Query Contact */}
            <div>
              <label className="text-[10px] font-bold text-blue-600 uppercase tracking-widest mb-1.5 block">
                Query Contact
              </label>
              {queryList.length === 0 ? (
                <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-700">
                  <RiErrorWarningLine className="w-4 h-4 flex-shrink-0" />
                  No query contacts found. Add one in Company Settings.
                </div>
              ) : (
                <select
                  value={
                    selectedQuery
                      ? JSON.stringify({
                          contactPersonName: selectedQuery.contactPersonName,
                          phone: selectedQuery.phone,
                        })
                      : ""
                  }
                  onChange={(e) =>
                    setSelectedQuery(
                      e.target.value ? JSON.parse(e.target.value) : null,
                    )
                  }
                  className={inputCls}
                >
                  <option value="">— Select query contact —</option>
                  {queryList.map((q, i) => (
                    <option
                      key={i}
                      value={JSON.stringify({
                        contactPersonName: q.contactPersonName,
                        phone: q.phone,
                      })}
                    >
                      {q.contactPersonName}
                      {q.phone ? ` — ${q.phone}` : ""}
                    </option>
                  ))}
                </select>
              )}

              {selectedQuery && (
                <div className="mt-2 rounded-xl border border-blue-100 bg-blue-50/40 overflow-hidden">
                  <div className="flex items-center gap-2 px-3 py-1.5 border-b border-blue-100 bg-blue-50">
                    <RiPhoneLine className="w-3 h-3 text-blue-500 flex-shrink-0" />
                    <span className="text-[9px] font-bold text-blue-600 uppercase tracking-widest">
                      Selected Contact
                    </span>
                  </div>
                  <div className="px-3 py-2 space-y-1">
                    {selectedQuery.contactPersonName && (
                      <div className="flex justify-between text-xs">
                        <span className="text-slate-400">Name</span>
                        <span className="text-slate-700 font-semibold">
                          {selectedQuery.contactPersonName}
                        </span>
                      </div>
                    )}
                    {selectedQuery.phone && (
                      <div className="flex justify-between text-xs">
                        <span className="text-slate-400">Phone</span>
                        <span className="text-slate-700 font-semibold font-mono">
                          {selectedQuery.phone}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="space-y-4">
          {groups.length === 0 ? (
            <div className="bg-white border border-blue-100 rounded-2xl shadow-sm flex flex-col items-center justify-center py-16 gap-3 text-slate-400">
              <RiInboxLine className="w-10 h-10 text-blue-200" />
              <p className="text-sm font-semibold">No sub-clients added yet.</p>
              <button
                onClick={addGroup}
                className="text-xs text-indigo-500 hover:underline flex items-center gap-1"
              >
                <RiAddLine className="w-3.5 h-3.5" /> Add a sub-client
              </button>
            </div>
          ) : (
            groups.map((group, gIdx) => (
              <BranchGroup
                key={group.id}
                group={group}
                groupIdx={gIdx}
                branches={branches}
                bankId={bankId}
                clientName={clientName}
                onUpdateGroup={updateGroup}
                onRemoveGroup={removeGroup}
                onAddBorrower={addBorrower}
                onUpdateBorrower={updateBorrower}
                onRemoveBorrower={removeBorrower}
                onBranchCreated={handleBranchCreated}
                notify={notify}
              />
            ))
          )}
        </div>

        <button
          onClick={addGroup}
          className="w-full flex items-center justify-center gap-2 py-3 border-2 border-dashed border-indigo-200 text-indigo-500 rounded-2xl text-sm font-semibold hover:border-indigo-400 hover:bg-indigo-50/50 transition"
        >
          {branchLoading ? (
            <Spinner className="w-4 h-4" />
          ) : (
            <RiAddLine className="w-4 h-4" />
          )}
          Add Sub-client Row
        </button>

        <div className="flex items-center justify-between gap-4 flex-wrap pt-2">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2.5 border border-slate-200 text-slate-600 rounded-xl text-sm font-semibold hover:bg-slate-50 transition"
          >
            <RiArrowLeftLine className="w-4 h-4" />
            Back to Invoices
          </button>

          <div className="flex items-center gap-3">
            {!isBalanced && groups.length > 0 && (
              <span className="text-xs text-amber-600 font-semibold">
                {allocatedSubTotal > invoiceSubTotal
                  ? `Over by ₹${fmt(allocatedSubTotal - invoiceSubTotal)}`
                  : `₹${fmt(invoiceSubTotal - allocatedSubTotal)} remaining to allocate`}
              </span>
            )}
            <button
              onClick={handleSave}
              disabled={saving || !isBalanced || groups.length === 0}
              className="flex items-center gap-2 px-6 py-2.5 bg-indigo-600 text-white rounded-xl text-sm font-bold shadow-md shadow-indigo-200 hover:bg-indigo-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {saving ? (
                <Spinner className="w-4 h-4" />
              ) : (
                <RiSaveLine className="w-4 h-4" />
              )}
              {saving ? "Saving…" : "Save Split Bills"}
            </button>
          </div>
        </div>
      </div>

      {showSummary && (
        <SplitBillSummaryModal
          invoice={{ invoiceNumber }}
          splitBills={existingSplitBills}
          splitBillType={existingSplitBillType}
          onClose={() => setShowSummary(false)}
        />
      )}

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default Splitbills;
